import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => {
    return css`
      padding: ${theme.spacing[4]}px;
      gap: ${theme.spacing[5]}px;
    `;
  }};
`;

export const ContainerEscolhaValor = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing['2']}px 0px;
  gap: ${({ theme }) => theme.spacing['4']}px;
`;

export const ContainerQuantidade = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const BotaoEscolhaPlano = styled.button`
  background: none;
  outline: none;
`;

export const ContainerPrecoPlano = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ContainerCarrinho = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  justify-content: space-between;
`;

export const ContainerPrecos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: ${({ theme }) => theme.spacing['1']}px;
`;

export const ContainerDetalhesAccordion = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerPlanos = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: ${({ theme }) => theme.spacing['5']}px;
  padding-bottom: ${({ theme }) => theme.spacing['8']}px;
  gap: ${({ theme }) => theme.spacing['4']}px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing['4']}px;

  padding: 0 ${({ theme }) => theme.spacing['4']}px;
`;
